<div *ngIf="isBrowser && !screenResolution.isMobile()">
  <section class="flex justify-content-center flex-wrap gap-8 mt-7">
    <div class="cstm-mr-right">
      <div class="text-6xl font-semibold text-700 letter-spacing">
        Advanced Crypto <br />
        Derivatives Built for Pro <br />
        Traders
      </div>
      <div
        class="mt-5 text-muted opacity-70 line-height-3 font-medium letter-spacing"
      >
        Experience 24/7 markets, smart margining, and seamless INR settlements
        <br />
        built for serious F&O traders.
      </div>
      <div class="mt-7 flex gap-5">
        <div
          (click)="addFunds()"
          class="py-2 w-4 text-sm cursor-pointer highlight-bg border-round-sm text-center flex-wrap header-height"
        >
          <div class="text-center">Add Funds</div>
        </div>
        <a
          href="/downloads/coinwush.apk"
          download
          class="apk-download-btn flex align-items-center gap-2 border-round-sm"
        >
          <i class="pi pi-android"></i>
          <span>Download App</span>
        </a>
        <!-- <div class="py-2 font-medium text-700 cursor-pointer">Watch video</div> -->
      </div>
      <!-- <div class="mt-5 text-sm font-medium opacity-70 text-muted">
        <i class="pi pi-verified mr-2 orange"></i
        ><span class="underline text-900">FIU-IND</span> registered and fully
        compliant with all Indian regulatory requirements.
      </div> -->
    </div>
    <div class="relative image-wrapper">
      <img src="../../../assets/home1.png" width="368px" />
    </div>
  </section>
  <section class="flex justify-content-center flex-wrap gap-8 bg-white mt-7">
    <div class="mt8 text-center w-full">
      <h1 class="text-4xl">
        Institutional-Grade F&O Trading for the Digital Asset Era
      </h1>
      <div class="font-medium opacity-70 text-muted">
        Leverage your expertise in traditional derivatives with a seamless
        <br />
        transition to crypto markets — all within a compliant, intuitive, and
        high-performance trading environment.
      </div>
      <div class="flex-wrap mt-3 flex justify-content-center">
        <div class="col-4">
          <img src="../../../assets/home2.png" width="300px" />
        </div>
        <div class="text-left cstm-padding col-8 mt-8">
          <div class="flex justify-content-center flex-wrap">
            <div class="p-4 col-6">
              <div
                class="msg border-round-md flex align-items-center justify-content-center"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-mail icon-dual-primary"
                >
                  <g>
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    ></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </g>
                </svg>
              </div>
              <div class="mt-3 font-medium">
                Trade Smart with 50% Lower Brokerage
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Why pay more? Switch to our platform and <br />
                enjoy half the brokerage compared to other <br />
                exchanges—maximize every trade with unbeatable savings.
              </div>
            </div>
            <div class="p-4 col-6">
              <div
                class="border-round-md flex align-items-center justify-content-center msg"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-bell icon-dual-info"
                >
                  <g>
                    <path
                      d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                    ></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </g>
                </svg>
              </div>

              <div class="mt-3 font-medium">P&L Analytics</div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Effortlessly monitor and analyze your <br />
                trading performance with powerful, real-time <br />
                insights designed to help you grow.
              </div>
            </div>
          </div>
          <div class="flex justify-content-center flex-wrap">
            <div class="p-4 col-6">
              <div
                class="bg-soft-orange border-round-md flex align-items-center justify-content-center"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-sliders icon-dual-orange"
                >
                  <g>
                    <line x1="4" y1="21" x2="4" y2="14"></line>
                    <line x1="4" y1="10" x2="4" y2="3"></line>
                    <line x1="12" y1="21" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12" y2="3"></line>
                    <line x1="20" y1="21" x2="20" y2="16"></line>
                    <line x1="20" y1="12" x2="20" y2="3"></line>
                    <line x1="1" y1="14" x2="7" y2="14"></line>
                    <line x1="9" y1="8" x2="15" y2="8"></line>
                    <line x1="17" y1="16" x2="23" y2="16"></line>
                  </g>
                </svg>
              </div>
              <div class="mt-3 font-medium">
                Daily, Weekly, and Monthly Expiries — Trade Your Strategy
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Enhance your trading edge with a variety <br />
                of expiry options, enabling precision in <br />
                both short-term and long-term strategies.
              </div>
            </div>
            <div class="p-4 col-6">
              <div
                class="border-round-md flex align-items-center justify-content-center bg-soft-success"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-shield icon-dual-success"
                >
                  <g>
                    <path
                      d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                    ></path>
                  </g>
                </svg>
              </div>

              <div class="mt-3 font-medium">
                Ironclad Security You Can Trust
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Your assets deserve top-tier protection. <br />
                With advanced encryption, multi-layer authentication, <br />
                and <span class="text-900 font-medium">24/7</span> monitoring,
                we ensure your trading experience <br />
                is as secure as a vault.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center bg-white pb-8 pt-7">
    <div class="text-center w-full">
      <h1 class="text-4xl">Start Trading in Minutes</h1>
      <div class="font-medium opacity-70 text-muted">
        Begin your crypto futures and options journey instantly—no need to own
        crypto to get started.
      </div>
    </div>
    <div class="gap-8 mt-7 flex justify-content-center">
      <div>
        <div class="text-2xl font-medium">Complete KYC Verification</div>
        <div class="text-center mt-3 opacity-90 text-muted">
          Keep your Aadhar and PAN handy. KYC takes < 1 min
        </div>
        <div class="start-kyc shadow-1">
          <img
            src="../../../assets/customer.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
      <div>
        <div class="text-2xl font-medium">
          Link Bank Account And Deposit INR
        </div>
        <div class="text-center mt-3 opacity-90 text-muted">
          Conveniently deposit INR directly from <br />
          your bank account. Crypto not needed to trade
        </div>
        <div class="trading-img shadow-1">
          <img
            src="../../../assets/mobile-banking.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
      <div>
        <div class="text-2xl font-medium">Start Trading</div>
        <div class="text-center mt-3 opacity-90 text-muted">
          Start trading futures and options on BTC and ETH
        </div>
        <div class="start-trading shadow-1">
          <img
            src="../../../assets/stock-market.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
    </div>
  </section>
  <section class="pt-8 text-center mb-8">
    <h1 class="text-4xl">Frequently Asked Questions</h1>
    <div class="gap-8 mt-7 flex justify-content-center">
      <div class="flex justify-content-center text-left">
        <div
          class="border-1 border-100 w-25rem py-4 px-4 h-30rem border-round-lg bg-white box"
        >
          <div class="text-5xl">24x7 Customer Support</div>
          <div class="mt-6 font-medium">Have a question?</div>
          <div class="mt-2 font-medium opacity-70 text-muted">
            Go to
            <span class="underline orange" (click)="navigate('/support')"
              >Support Centre</span
            >
            to do a quick search
          </div>
          <div class="mt-4 font-medium">Need more help?</div>
          <div class="mt-2 font-medium opacity-70 text-muted">
            Raise a
            <span class="underline orange" (click)="navigate('/support')"
              >Support</span
            >
            ticket We are here to help
          </div>
        </div>
      </div>
      <div class="card w-3">
        <p-panel
          header="Can i buy crypto on Coinwush"
          [toggleable]="true"
          styleClass="border-1 border-100"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            No you can not but crypto on Coinwush. You can only trade using INR.
          </p>
        </p-panel>
        <p-panel
          header="What is liquidation and how can I avoid it?"
          [toggleable]="true"
          styleClass="mt-4"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            Liquidation occurs when your margin balance is no longer sufficient
            to keep a leveraged position open. This happens when the market
            moves against your trade beyond a certain threshold.
          </p>
        </p-panel>
        <p-panel
          header="Can i trade Spot in Coinwush"
          [toggleable]="true"
          styleClass="mt-4"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            No you can not trade Spot on Coinwush. Currently that feature is
            under development. Soon it will be available for trading.
          </p>
        </p-panel>
      </div>
    </div>
    <div>
      <div></div>
      <div></div>
    </div>
  </section>
</div>

<div *ngIf="isBrowser && screenResolution.isMobile()">
  <div
    class="flex justify-content-between align-items-center py-2 px-2 relative border-bottom-2 border-200"
  >
    <div>
      <img src="../../../assets/coinwush.png" style="width: 145px" />
    </div>
    <div
      class="text-sm font-semibold text-700 flex justify-content-between gap-3"
    >
      <div
        class="cursor-pointer text-center py-2 px-3 highlight-bg border-round-xs text-xs font-medium order-place button-color"
        (click)="navigate('/user/signup')"
      >
        <div>Sign Up</div>
      </div>
      <div class="flex align-items-center" (click)="sidebarVisible = true">
        <i class="pi pi-align-right"></i>
      </div>
    </div>
  </div>
  <section class="flex justify-content-center flex-wrap gap-5 mt-3 px-3">
    <div>
      <div class="text-2xl font-semibold text-700 letter-spacing">
        Advanced Crypto Derivatives Built for Pro Traders
      </div>
      <div
        class="mt-4 text-muted opacity-70 line-height-3 font-medium letter-spacing"
      >
        Experience 24/7 markets, smart margining, and seamless INR settlements
        <br />
        built for serious F&O traders.
      </div>
      <div class="mt-7 flex gap-5">
        <a
          href="/downloads/coinwush.apk"
          download
          class="apk-download-btn flex align-items-center gap-2 border-round-sm"
        >
          <i class="pi pi-android"></i>
          <span>Download App</span>
        </a>
        <div class="py-2 font-medium text-700 cursor-pointer">
          <div class="text-center" (click)="navigate('/user/login')">
            Log In
          </div>
        </div>
      </div>
      <div class="mt-5 text-sm font-medium opacity-70 text-muted line-height">
        <!-- <i class="pi pi-verified mr-2 orange"></i
        ><span class="underline text-900">FIU-IND</span> registered and fully
        compliant with all Indian regulatory requirements. -->
      </div>
    </div>
    <div class="relative">
      <img src="../../../assets/home1.png" width="200px" />
    </div>
  </section>
  <section class="flex justify-content-center flex-wrap gap-8 bg-white">
    <div class="mt8 text-center w-full px-2">
      <h1 class="text-2xl">
        Institutional-Grade F&O Trading for the Digital Asset Era
      </h1>
      <div class="font-medium opacity-70 text-muted text-sm">
        Leverage your expertise in traditional derivatives with a seamless
        transition to crypto markets — all within a compliant, intuitive, and
        high-performance trading environment.
      </div>
      <div class="flex-wrap mt-3">
        <div>
          <img src="../../../assets/home2.png" width="200px" />
        </div>
        <div class="text-left mt-4">
          <div>
            <div class="p-4 col-12">
              <div
                class="msg border-round-md flex align-items-center justify-content-center"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-mail icon-dual-primary"
                >
                  <g>
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    ></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </g>
                </svg>
              </div>
              <div class="mt-3 font-medium">
                Trade Smart with 50% Lower Brokerage
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Why pay more? Switch to our platform and <br />
                enjoy half the brokerage compared to other <br />
                exchanges—maximize every trade with unbeatable savings.
              </div>
            </div>
            <div class="p-4 col-12">
              <div
                class="border-round-md flex align-items-center justify-content-center msg"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-bell icon-dual-info"
                >
                  <g>
                    <path
                      d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                    ></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </g>
                </svg>
              </div>

              <div class="mt-3 font-medium">P&L Analytics</div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Effortlessly monitor and analyze your <br />
                trading performance with powerful, real-time <br />
                insights designed to help you grow.
              </div>
            </div>
          </div>
          <div>
            <div class="p-4 col-12">
              <div
                class="bg-soft-orange border-round-md flex align-items-center justify-content-center"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-sliders icon-dual-orange"
                >
                  <g>
                    <line x1="4" y1="21" x2="4" y2="14"></line>
                    <line x1="4" y1="10" x2="4" y2="3"></line>
                    <line x1="12" y1="21" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12" y2="3"></line>
                    <line x1="20" y1="21" x2="20" y2="16"></line>
                    <line x1="20" y1="12" x2="20" y2="3"></line>
                    <line x1="1" y1="14" x2="7" y2="14"></line>
                    <line x1="9" y1="8" x2="15" y2="8"></line>
                    <line x1="17" y1="16" x2="23" y2="16"></line>
                  </g>
                </svg>
              </div>
              <div class="mt-3 font-medium">
                Daily, Weekly, and Monthly Expiries — Trade Your Strategy
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Enhance your trading edge with a variety <br />
                of expiry options, enabling precision in <br />
                both short-term and long-term strategies.
              </div>
            </div>
            <div class="p-4 col-12">
              <div
                class="border-round-md flex align-items-center justify-content-center bg-soft-success"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-shield icon-dual-success"
                >
                  <g>
                    <path
                      d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                    ></path>
                  </g>
                </svg>
              </div>

              <div class="mt-3 font-medium">
                Ironclad Security You Can Trust
              </div>
              <div class="mt-2 opacity-70 text-muted line-height">
                Your assets deserve top-tier protection. <br />
                With advanced encryption, multi-layer authentication, <br />
                and <span class="text-900 font-medium">24/7</span> monitoring,
                we ensure your trading experience <br />
                is as secure as a vault.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center bg-white pb-6 pt-4">
    <div class="text-center w-full">
      <h1 class="text-2xl mt-4">Start Trading in Minutes</h1>
      <div class="font-medium opacity-70 text-muted px-2 text-sm">
        Begin your crypto futures and options journey instantly—no need to own
        crypto to get started.
      </div>
    </div>
    <div class="gap-8 mt-7">
      <div>
        <div class="text-2xl font-medium">Complete KYC Verification</div>
        <div class="text-center mt-3 opacity-90 text-muted px-2 text-sm">
          Keep your Aadhar and PAN handy. KYC takes < 1 min
        </div>
        <div class="start-kyc shadow-1">
          <img
            src="../../../assets/customer.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
      <div>
        <div class="text-2xl font-medium">
          Link Bank Account And Deposit INR
        </div>
        <div class="text-center mt-3 opacity-90 text-muted px-2 text-sm">
          Conveniently deposit INR directly from <br />
          your bank account. Crypto not needed to trade
        </div>
        <div class="trading-img shadow-1">
          <img
            src="../../../assets/mobile-banking.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
      <div>
        <div class="text-2xl font-medium">Start Trading</div>
        <div class="text-center mt-3 opacity-90 text-muted px-2 text-sm">
          Start trading futures and options on BTC and ETH
        </div>
        <div class="start-trading shadow-1">
          <img
            src="../../../assets/stock-market.png"
            class="mt-4 cursor-pointer"
            style="width: 90px"
          />
        </div>
      </div>
    </div>
  </section>
  <section class="pt-4 text-center mb-8 px-2">
    <h1 class="text-2xl">Frequently Asked Questions</h1>
    <div class="gap-8 mt-4">
      <div class="flex justify-content-center text-left">
        <div
          class="border-1 border-100 w-25rem py-4 px-4 h-30rem border-round-lg bg-white box"
        >
          <div class="text-4xl">24x7 Customer Support</div>
          <div class="mt-6 font-medium">Have a question?</div>
          <div class="mt-2 font-medium opacity-70 text-muted">
            Go to <span class="underline orange">Support Centre</span> to do a
            quick search
          </div>
          <div class="mt-4 font-medium">Need more help?</div>
          <div class="mt-2 font-medium opacity-70 text-muted">
            Raise a <span class="underline orange">Support</span> ticket We are
            here to help
          </div>
        </div>
      </div>
      <div class="card mt-5">
        <p-panel
          header="Can i buy crypto on Coinwush"
          [toggleable]="true"
          styleClass="border-1 border-100"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            No you can not but crypto on Coinwush. You can only trade using INR.
          </p>
        </p-panel>
        <p-panel
          header="What is liquidation and how can I avoid ?"
          [toggleable]="true"
          styleClass="mt-4"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            Liquidation occurs when your margin balance is no longer sufficient
            to keep a leveraged position open. This happens when the market
            moves against your trade beyond a certain threshold.
          </p>
        </p-panel>
        <p-panel
          header="Can i trade Spot in Coinwush"
          [toggleable]="true"
          styleClass="mt-4"
        >
          <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
            No you can not trade Spot on Coinwush. Currently that feature is
            under development. Soon it will be available for trading.
          </p>
        </p-panel>
      </div>
    </div>
    <div>
      <div></div>
      <div></div>
    </div>
  </section>
</div>

<!-- <div class="card flex justify-content-center" *ngIf="isBrowser">
  <p-sidebar
    [(visible)]="sidebarVisible"
    position="right"
    styleClass="w-15rem px-0"
  >
    <div
      class="py-3 border-bottom-1 border-100 flex flex-wrap"
      (click)="navigate('/trading/market')"
    >
      <div><i class="pi pi-chart-bar font-medium text-500"></i></div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Market
      </div>
    </div>
    <div
      class="py-3 border-bottom-1 border-100 flex flex-wrap"
      (click)="navigate('/trading/pairs')"
    >
      <div><i class="pi-chart-line pi font-medium text-500"></i></div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Futures
      </div>
    </div>
    <div
      class="py-3 border-bottom-1 border-100 flex flex-wrap"
      (click)="navigate('/trading/chart')"
    >
      <div><i class="pi-bolt pi font-medium text-500"></i></div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Options
      </div>
    </div>
    <div class="py-3 border-bottom-1 border-100 flex flex-wrap">
      <div><i class="pi-headphones pi font-medium text-500"></i></div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Support
      </div>
    </div>
    <div class="py-3 border-bottom-1 border-100 flex flex-wrap">
      <div>
        <i class="pi pi-arrow-right-arrow-left font-medium text-500"></i>
      </div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Themes
      </div>
    </div>
    <div class="py-3 border-bottom-1 border-100 flex flex-wrap">
      <div><i class="pi-mobile pi font-medium text-500"></i></div>
      <div class="pl-3 text-xs font-medium text-500 flex align-items-center">
        Download App
      </div>
    </div>

    <div class="col-12 px-0 mb-1 mt-6">
      <div
        class="cursor-pointer text-center w-12 py-2 highlight-bg border-round-xs text-sm font-medium order-place button-color"
        (click)="navigate('/user/login')"
      >
        <div>Log in</div>
      </div>
    </div>

    <div class="col-12 px-0 mb-3">
      <div
        class="cursor-pointer text-center w-12 py-2 surface-200 border-round-xs text-sm font-medium order-place button-color"
        (click)="navigate('/user/signup')"
      >
        <div>Sign up</div>
      </div>
    </div>
  </p-sidebar>
</div> -->

<div class="card flex justify-content-center" *ngIf="isBrowser">
  <p-sidebar
    [(visible)]="sidebarVisible"
    position="right"
    styleClass="w-15rem px-0 mobile-sidebar"
  >
    <!-- Menu Section -->
    <div class="menu-list">
      <div class="menu-item" (click)="navigate('/trading/market')">
        <i class="pi pi-chart-bar menu-icon"></i>
        <span class="menu-text">Market</span>
      </div>

      <div class="menu-item" (click)="navigate('/trading/pairs')">
        <i class="pi pi-chart-line menu-icon"></i>
        <span class="menu-text">Futures</span>
      </div>

      <div class="menu-item" (click)="navigate('/trading/chart')">
        <i class="pi pi-bolt menu-icon"></i>
        <span class="menu-text">Trade</span>
      </div>

      <div class="menu-item" (click)="navigate('/fees')">
        <i class="pi pi-calculator menu-icon"></i>
        <span class="menu-text">Fees</span>
      </div>

      <a href="/downloads/coinwush.apk" class="menu-item" download>
        <i class="pi pi-mobile menu-icon"></i>
        <span class="menu-text">Download App</span>
      </a>
    </div>

    <!-- Divider -->
    <div class="menu-divider"></div>

    <!-- Auth Section -->

    <div class="col-12 px-0 mb-1 mt-6">
      <div
        class="cursor-pointer text-center w-12 py-2 highlight-bg border-round-xs text-sm font-medium order-place button-color"
        (click)="navigate('/user/login')"
      >
        <div>Log in</div>
      </div>
    </div>
    <div class="grid w-full my-1">
      <div class="col-5 p-0">
        <hr class="border-100 border-1" />
      </div>
      <div class="col-2 text-center p-0 text-600">or</div>
      <div class="col-5 p-0">
        <hr class="border-100 border-1" />
      </div>
    </div>
    <div class="col-12 px-0 mb-3">
      <div
        class="cursor-pointer text-center w-12 py-2 surface-200 border-round-xs text-sm font-medium order-place button-color"
        (click)="navigate('/user/signup')"
      >
        <div>Sign up</div>
      </div>
    </div>
  </p-sidebar>
</div>
